"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BuildingCard_1 = __importDefault(require("./BuildingCard"));
var ApartmentsCard_1 = __importDefault(require("./ApartmentsCard"));
var SimpleCard_1 = __importDefault(require("./SimpleCard"));
var MortgageCard_1 = __importDefault(require("./MortgageCard"));
var PostTabsContext_1 = require("../../../../../contexts/PostTabsContext");
var GeneralSettings_1 = require("../../../../../constants/GeneralSettings");
var PostViewContentTypes_1 = require("../../../../../constants/PostViewContentTypes");
var DeveloperSectionsContainer = function (_a) {
    var steps = _a.steps, formikProps = _a.formikProps, post = _a.post, isLoaded = _a.isLoaded, removeParentEntityMedia = _a.removeParentEntityMedia, reorderMedia = _a.reorderMedia, handleSubmitApartmentForm = _a.handleSubmitApartmentForm, isApartmentFormSubmitted = _a.isApartmentFormSubmitted, setCollapsedApartmentId = _a.setCollapsedApartmentId, collapsedApartmentId = _a.collapsedApartmentId, setIsApartmentFormSubmitted = _a.setIsApartmentFormSubmitted;
    var handleChangeSchema = react_1.useContext(PostTabsContext_1.PostTabsContext).handleChangeSchema;
    var isAvailableMortgage = react_1.useMemo(function () {
        var currentConfig = steps[3].config.displayCondition; // steps[3] is equal to mortgage data
        return (currentConfig.visibleSections.deal.includes(formikProps.values.deal) &&
            currentConfig.visibleSections.propertyType.includes(formikProps.values.initial_info.property_type));
    }, [
        formikProps.values.deal,
        formikProps.values.initial_info.property_type,
    ]);
    react_1.useEffect(function () {
        handleChangeSchema({
            deal: formikProps.values.deal,
            propertyType: formikProps.values.initial_info.property_type,
        });
    }, [
        formikProps.values.deal,
        formikProps.values.initial_info.property_type,
    ]);
    react_1.useEffect(function () {
        if (formikProps.values.deal === GeneralSettings_1.DEAL_TYPES.RENT) {
            formikProps.setFieldValue('initial_info.exploitation', 'yes');
        }
        if (PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO ===
            formikProps.values.initial_info.property_type ||
            formikProps.values.deal === GeneralSettings_1.DEAL_TYPES.RENT) {
            var mortgageIds = formikProps.values.mortgage.map(function (item) { return item.id; });
            formikProps.setFieldValue('removedMortgageIds', mortgageIds);
            formikProps.setFieldValue('mortgage', [{ id: 0 }]);
        }
        else if (formikProps.values.deal !== GeneralSettings_1.DEAL_TYPES.RENT) {
            formikProps.setFieldValue('removedMortgageIds', []);
        }
    }, [
        formikProps.values.deal,
        formikProps.values.initial_info.property_type,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SimpleCard_1.default, { step: steps[0], formikProps: formikProps, post: post, isLoaded: isLoaded, reorderMedia: reorderMedia }),
        react_1.default.createElement(SimpleCard_1.default, { step: steps[1], formikProps: formikProps, post: post, isLoaded: isLoaded, reorderMedia: reorderMedia }),
        react_1.default.createElement(BuildingCard_1.default, { step: steps[2], formikProps: formikProps, post: post, isLoaded: isLoaded, removeParentEntityMedia: removeParentEntityMedia, reorderMedia: reorderMedia }),
        isAvailableMortgage && (react_1.default.createElement(MortgageCard_1.default, { step: steps[3], formikProps: formikProps, post: post, isLoaded: isLoaded })),
        react_1.default.createElement(ApartmentsCard_1.default, { step: steps[4], formikProps: formikProps, post: post, isLoaded: isLoaded, handleSubmitApartmentForm: handleSubmitApartmentForm, isApartmentFormSubmitted: isApartmentFormSubmitted, setCollapsedApartmentId: setCollapsedApartmentId, collapsedApartmentId: collapsedApartmentId, setIsApartmentFormSubmitted: setIsApartmentFormSubmitted }),
        react_1.default.createElement(SimpleCard_1.default, { step: steps[5], formikProps: formikProps, post: post, isLoaded: isLoaded, reorderMedia: reorderMedia })));
};
exports.default = DeveloperSectionsContainer;
